import { Outlet } from 'react-router-dom';
import { TenantProvider } from '@/contexts/TenantContext';

export const RootLayout = () => {
  return (
    <TenantProvider>
      <Outlet />
    </TenantProvider>
  );
};
